/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import {
  Table,
  Form,
  Button,
  Badge,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import CommonScrollBar from "../../Common/CommonScrollBar";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../../App";
import Select from "react-select";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import {
  SearchPincodeList,
  StartCommonLoader,
  ErrorMessageFromRedux,
  StartMainCommonLoader,
} from "../../../redux/actions/adminActions";
import CheckValid from "../../Common/CheckValid";
import {
  parsePhoneNumber,
  getRegionCodeForCountryCode,
} from "awesome-phonenumber";
import CommonewModel from "../../Common/CommonewModel";
import AmountNumberFormat from "../../Common/AmountNumberFormat";
import CommonToggle from "../../Common/CommonToggle";
import { toast } from "react-toastify";
import CommonAddressTextField from "../../Common/CommonAddressTextField";
import DeleteIcon from "../../../assets/img/delete_icon.svg";
import { customFilterOption } from "../../Common/customFilterOption";

const FranchiseOrderTab = (props) => {
  const {
    RouteName,
    PermissionStockInwardModule,
    setPermissionStockInwardModule,
    DistributorAllow,
  } = props;
  const Dispatch = useDispatch();
  const { websocket } = useContext(WebSocketContext);
  const {
    device_id,
    ClearFormSet,
    selfInfo,
    AllDealerFranchiseTypeListAll,
    franchiseTypeListAll,
    FranchiseUserTypeList,
    subCategorylistall,
    categorylistall,
    productlistall,
    sparescampatibiityAllList,
    ErrorMessageFromReddux,
    searchPincodeList,
    commonLoader,
    bundlesItemAllList,
    saleTypeAllList,
    erpAccountListSOrder,
    wareHouselistall,
  } = useSelector((state) => state.adminReducers);

  const [selectFranchise, setselectFranchise] = useState("");
  const [IsPreOrder, setIsPreOrder] = useState(false);
  const [sparesCampatProduct, setSparesCampatProduct] = useState("");
  const [selectProduct, setselectProduct] = useState("");
  const [selectBundlesItem, setselectBundlesItem] = useState("");
  const [selectParentBundlesItem, setselectParentBundlesItem] = useState("");
  const [selectSubCategory, setselectSubCategory] = useState("");
  const [selectCategory, setselectCategory] = useState("");
  const [selectItemName, setselectItemName] = useState("");
  const [IsDemo, setIsDemo] = useState(false);
  const [AddQuantity, setAddQuantity] = useState("");
  const [AddRate, setAddRate] = useState("");
  const [optionsAllDealerFranchise, setoptionsAllDealerFranchise] = useState(
    [],
  );
  const optionsProducts = productlistall
    ?.filter((elm) => !elm?.custom_is_transportation)
    ?.map((item, index) => ({
      ...item,
      key: item.id,
      value: item?.id,
      label: item?.product_name,
    }));
  const optionsProductsTransportation = productlistall
    ?.filter((elm) => elm?.custom_is_transportation)
    ?.map((item, index) => ({
      ...item,
      key: item.id,
      value: item?.id,
      label: item?.product_name,
    }));
  const optionsBundlesItems = bundlesItemAllList?.data?.map((item, index) => ({
    ...item,
    key: item.id,
    value: item?.id,
    label: item?.parent_id,
  }));
  const optionSaleTypeAllList = saleTypeAllList
    ?.filter((elm) => elm?.sale_type === "After Sales")
    ?.map((item, index) => ({
      ...item,
      key: item.id,
      value: item?.id,
      label: item?.sale_type,
    }))[0];
  const [optionsCategory, setoptionsCategory] = useState(() =>
    categorylistall?.map((item, index) => ({
      key: item.id,
      value: item?.id,
      label: item?.category_name,
    })),
  );
  const [optionsSubCategory, setoptionsSubCategory] = useState([]);
  const [optionsItemName, setoptionsItemName] = useState(() =>
    productlistall
      ?.filter((elm) => !elm?.custom_is_transportation)
      ?.map((item, index) => ({
        key: item.id,
        value: item?.id,
        label: item?.product_name,
      })),
  );
  const optionsSparesListproductlistall = productlistall
    ?.filter((elm) => elm?.is_active && elm?.is_spare)
    .reduce((acc, curr) => {
      acc[curr.id] = curr;
      return acc;
    }, {});
  const optionsparescampatibiityAllList = sparescampatibiityAllList
    ?.filter((elm) => elm?.product_id !== "None")
    ?.filter(
      (elm) => optionsSparesListproductlistall[elm?.product_id]?.is_spare,
    )
    ?.map((item, index) => ({
      ...item,
      key: item.id,
      value: item?.id,
      label: item?.compatible_item_name,
    }));
  let GetCurrentDealerFranchiseType =
    AllDealerFranchiseTypeListAll?.list?.filter(
      (elm) => elm?.id === selectFranchise,
    )[0];
  const [ApplicationState, setApplicationState] = useState({
    Name: "",
    Mobile: "",
    Email: "",
    PINCode: "",
    PANCard: "",
    GSTIN: "",
    Address: "",
    Remark: "",
    address2: "",
  });
  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    description: "",
    Data: {},
  });
  const [PreviewOrder, setPreviewOrder] = useState(false);
  const ParentDealerFranchiseList = AllDealerFranchiseTypeListAll?.list;
  const FranchiseListStateVars =
    ParentDealerFranchiseList &&
    ParentDealerFranchiseList?.filter((elm) => {
      if (elm?.id === selectFranchise) {
        return elm;
      } else if (elm?.parent_id === selectFranchise) {
        return elm;
      }
    });
  const FranchiseListStateVarsWithIncludeOther = [
    ...FranchiseListStateVars,
    { id: "", customer_name: "Other" },
  ];
  const FranchiseListStateVarsOptions =
    FranchiseListStateVarsWithIncludeOther?.map((item, index) => ({
      ...item,
      key: item.id,
      value: item?.id,
      label: item?.customer_name,
    }));
  const [FranchiseDealerAddress, setFranchiseDealerAddress] = useState("");
  const [Tab, setTab] = useState("franchise_order");
  const exceptThisCostSymbolsBox = ["e", "E", "+", "-"];
  const exceptThisCostSymbols = ["e", "E", "+", "-", "."];
  const EmailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/; // eslint-disable-line
  const pinRegex = /^\d{6}$/; // eslint-disable-line
  const PermissionsAccess = selfInfo?.user?.permissions_access;

  // error state
  const [errorPINCode, seterrorPINCode] = useState("");
  const [errorName, seterrorName] = useState("");
  const [errorMobile, seterrorMobile] = useState("");
  const [errorEmail, seterrorEmail] = useState("");
  const [errorAddress, seterrorAddress] = useState("");
  const [errorAddress2, seterrorAddress2] = useState("");
  const [errorGSTIN, seterrorGSTIN] = useState("");

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      fontSize: "13px", // Adjust the font size as per your requirement
    }),
  };

  // pin code error get from redux
  useEffect(() => {
    if (
      ErrorMessageFromReddux?.API === "pin_code_search" &&
      ErrorMessageFromReddux?.Error !== ""
    ) {
      seterrorPINCode(ErrorMessageFromReddux?.Error);
    }
  }, [ErrorMessageFromReddux]);

  // ERP ACCOUNT API CALL
  useEffect(() => {
    if (selectFranchise !== "") {
      let param = {
        transmit: "broadcast",
        url: "erp_account",
        request: {
          search: "",
          limit: 5000,
          page_no: 1,
          from_date: null,
          to_date: null,
          franchise_id: selectFranchise,
          order_by: "-updated_at",
        },
        module_name: "erp-account-so-creation",
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    }
  }, [selectFranchise]);

  // useEffect(() => {
  //   let param = {
  //     transmit: "broadcast",
  //     url: "erp_stock_level_list",
  //     request: {
  //       status: "",
  //       limit: 5000,
  //       page_no: 1,
  //       search: "",
  //       from_date: null,
  //       to_date: null,
  //       warehouse_id: null,
  //       product_id: showModalNew?.Data,
  //     },
  //     DeviceId: device_id,
  //   };
  //   wsSend_request(websocket, param);
  // }, []);

  // options product listing
  const UpdateOptionPorducts = optionsProducts
    ?.filter((elm) => {
      if (DistributorAllow) {
        if (elm?.distributor_rate !== null && elm?.distributor_rate !== "") {
          return elm;
        }
      } else {
        return elm;
      }
    })
    ?.filter((product) => {
      if (
        PermissionStockInwardModule?.permissionStockInward === "Others" ||
        PermissionStockInwardModule?.permissionStockInward === "Bundles"
      ) {
        return product;
      } else {
        const SubCategorylist = subCategorylistall?.filter((subCategory) => {
          if (product?.sub_category_id === subCategory?.id) {
            categorylistall?.filter((catgorys) => {
              if (subCategory?.category_id === catgorys?.id) {
                if (
                  PermissionStockInwardModule?.permissionStockInward ===
                  "Spares"
                ) {
                  if (catgorys?.category_name === "Spares") {
                    return product;
                  }
                } else if (
                  PermissionStockInwardModule?.permissionStockInward ===
                  "E-Bikes,Accessories"
                ) {
                  if (
                    catgorys?.category_name === "Accessories" ||
                    catgorys?.category_name === "E-Bikes"
                  ) {
                    return product;
                  }
                }
              }
            });
          }
        });

        return SubCategorylist;
      }
    })
    ?.filter((elm) => elm?.include_online)
    ?.filter((elm) => (IsPreOrder ? elm?.pre_book : true));

  const GetAvailableBalance = () => {
    const CurrentSelectedFranchaise = ParentDealerFranchiseList?.filter(
      (elm) => elm?.id === selectFranchise,
    )[0];
    if (!CurrentSelectedFranchaise) {
      return AmountNumberFormat(0); // Return 0 or handle as needed if no franchise is found
    }

    const Available_balance_calculate =
      parseFloat(
        CurrentSelectedFranchaise?.erp_credit_limit === null
          ? 0
          : CurrentSelectedFranchaise?.erp_credit_limit,
      ) -
      (CurrentSelectedFranchaise?.erp_outstanding === null
        ? 0
        : CurrentSelectedFranchaise?.erp_outstanding);
    const erp_credit_limit_calculate = parseFloat(
      CurrentSelectedFranchaise?.erp_credit_limit === null
        ? 0
        : CurrentSelectedFranchaise?.erp_credit_limit,
    );
    const erp_outstanding_calculate = parseFloat(
      CurrentSelectedFranchaise?.erp_outstanding === null
        ? 0
        : CurrentSelectedFranchaise?.erp_outstanding,
    );

    return {
      available_balance: AmountNumberFormat(
        Available_balance_calculate < 0 ? 0 : Available_balance_calculate,
      ),
      available_balance_parsFloat:
        Available_balance_calculate < 0 ? 0 : Available_balance_calculate,
      erp_credit_limit: AmountNumberFormat(
        erp_credit_limit_calculate < 0 ? 0 : erp_credit_limit_calculate,
      ),
      erp_outstanding: AmountNumberFormat(
        erp_outstanding_calculate < 0 ? 0 : erp_outstanding_calculate,
      ),
    };
  };

  useEffect(() => {
    if (AllDealerFranchiseTypeListAll?.list?.length > 0) {
      if (
        selfInfo?.user?.user_type === "regional_manager" ||
        selfInfo?.user?.user_type === "regional_sales_team_rm"
      ) {
        setoptionsAllDealerFranchise(
          AllDealerFranchiseTypeListAll?.list
            ?.filter(
              (elm) =>
                elm?.parent_id === null &&
                elm?.region_manager_id === selfInfo?.user?.id,
            )
            ?.map((item, index) => ({
              key: item.id,
              value: item?.id,
              label: item?.customer_name,
            })),
        );
      } else if (selfInfo?.user?.user_type === "regional_sales_team_asm") {
        setoptionsAllDealerFranchise(
          AllDealerFranchiseTypeListAll?.list
            ?.filter(
              (elm) =>
                elm?.parent_id === null && elm?.asm_id === selfInfo?.user?.id,
            )
            ?.map((item, index) => ({
              key: item.id,
              value: item?.id,
              label: item?.customer_name,
            })),
        );
      } else {
        if (DistributorAllow) {
          setoptionsAllDealerFranchise(
            AllDealerFranchiseTypeListAll?.list
              ?.filter((elm) => elm?.parent_id === null && elm?.is_distributor)
              ?.map((item, index) => ({
                key: item.id,
                value: item?.id,
                label: item?.customer_name,
              })),
          );
        } else {
          setoptionsAllDealerFranchise(
            AllDealerFranchiseTypeListAll?.list
              ?.filter((elm) => elm?.parent_id === null && !elm?.is_distributor)
              ?.map((item, index) => ({
                key: item.id,
                value: item?.id,
                label: item?.customer_name,
              })),
          );
        }
      }
    }
  }, [AllDealerFranchiseTypeListAll, DistributorAllow]);

  useEffect(() => {
    if (FranchiseDealerAddress !== "") {
      if (FranchiseDealerAddress?.id === "") {
        if (FranchiseDealerAddress?.customer_name === "Other") {
          setApplicationState((ApplicationState) => ({
            ...ApplicationState,
            Name: "",
            Mobile: "",
            Email: "",
            PINCode: "",
            PANCard: "",
            Address: "",
            address2: "",
          }));
          Dispatch(SearchPincodeList({}));
          Dispatch(
            ErrorMessageFromRedux({
              API: "",
              Error: "",
            }),
          );
        } else {
          setApplicationState((ApplicationState) => ({
            ...ApplicationState,
            Name: "",
            Mobile: "",
            Email: "",
            // PINCode: "",
            PANCard: "",
            // GSTIN: "",
            Address: "",
            address2: "",
          }));
          // Dispatch(SearchPincodeList({}));
          Dispatch(
            ErrorMessageFromRedux({
              API: "",
              Error: "",
            }),
          );
        }
      } else {
        if (PreviewOrder) {
          let GetCurrentDealerFranchiseCurrent =
            AllDealerFranchiseTypeListAll?.list?.filter(
              (elm) => elm?.id === FranchiseDealerAddress?.value,
            )[0];
          let GetParentFranchiseCurrent = FranchiseListStateVarsOptions?.filter(
            (elm) => elm?.parent_id === null,
          )[0];

          const GetCurrentPincode = AllDealerFranchiseTypeListAll?.pin?.filter(
            (elm) => elm?.id === GetCurrentDealerFranchiseCurrent?.pin_code_id,
          )[0]?.pin_code;
          setApplicationState((ApplicationState) => ({
            ...ApplicationState,
            Name:
              GetParentFranchiseCurrent?.customer_name === null
                ? ""
                : GetParentFranchiseCurrent?.customer_name,
            Mobile:
              GetCurrentDealerFranchiseCurrent?.mobile === null
                ? ""
                : GetCurrentDealerFranchiseCurrent?.mobile,
            Email:
              GetCurrentDealerFranchiseCurrent?.email === null
                ? ""
                : GetCurrentDealerFranchiseCurrent?.email,
            PINCode: GetCurrentPincode,
            PANCard:
              GetParentFranchiseCurrent?.pan_no === null
                ? ""
                : GetParentFranchiseCurrent?.pan_no,
            GSTIN:
              GetParentFranchiseCurrent?.gst_no === null
                ? ""
                : GetParentFranchiseCurrent?.gst_no,
            Address:
              GetCurrentDealerFranchiseCurrent?.address === null
                ? ""
                : GetCurrentDealerFranchiseCurrent?.address,
            address2:
              GetCurrentDealerFranchiseCurrent?.address2 === null
                ? ""
                : GetCurrentDealerFranchiseCurrent?.address2,
          }));
          if (GetCurrentPincode?.length === 6) {
            Dispatch(StartCommonLoader(true));
            let param = {
              transmit: "broadcast",
              url: "pin_code_search",
              request: {
                pin_code: GetCurrentPincode,
              },
              DeviceId: device_id,
            };
            wsSend_request(websocket, param);
          } else {
            Dispatch(StartCommonLoader(false));
          }

          CheckValid(
            GetParentFranchiseCurrent?.customer_name === null
              ? ""
              : GetParentFranchiseCurrent?.customer_name,
            { type: "Customername", error: seterrorName },
          );
          CheckValid(
            GetCurrentDealerFranchiseCurrent?.mobile === null
              ? ""
              : GetCurrentDealerFranchiseCurrent?.mobile,
            { type: "phone", error: seterrorMobile },
          );
          CheckValid(GetCurrentPincode, {
            type: "PINCode",
            error: seterrorPINCode,
          });
          CheckValid(
            GetCurrentDealerFranchiseCurrent?.email === null
              ? ""
              : GetCurrentDealerFranchiseCurrent?.email,
            { type: "email", error: seterrorEmail },
          );
          CheckValid(
            GetCurrentDealerFranchiseCurrent?.address === null
              ? ""
              : GetCurrentDealerFranchiseCurrent?.address,
            { type: "Address", error: seterrorAddress },
          );
          CheckValid(
            GetCurrentDealerFranchiseCurrent?.address2 === null
              ? ""
              : GetCurrentDealerFranchiseCurrent?.address2,
            { type: "address2", error: seterrorAddress2 },
          );
        }
      }
    }
  }, [FranchiseDealerAddress, PreviewOrder]);

  // Franchise select
  const FranchiseSelect = (value) => {
    if (value !== null) {
      setselectFranchise(value?.value);
      setFranchiseDealerAddress(value);
    } else {
      setselectFranchise("");
    }
  };

  // Product select
  const ProductSparesSelect = (value) => {
    setSparesCampatProduct(value);
    if (value !== null) {
      const ProductCurrent = productlistall?.filter(
        (elm) => elm?.id === value?.product_id,
      )[0];
      const GetCurrentSubCategory = subCategorylistall?.filter(
        (elm) => elm?.id === ProductCurrent?.sub_category_id,
      )[0];
      setselectProduct(ProductCurrent);
      setselectSubCategory(GetCurrentSubCategory?.id);
      setselectCategory(GetCurrentSubCategory?.category_id);
    } else {
      setSparesCampatProduct("");
      setselectProduct("");
    }
  };

  const [FilterDisable, setFilterDisable] = useState(false);
  // Product select
  const ProductSelect = (value) => {
    if (value !== null) {
      setselectProduct(value);
      const ProductCurrent = productlistall?.filter(
        (elm) => elm?.id === value?.value,
      )[0];
      const GetCurrentSubCategory = subCategorylistall?.filter(
        (elm) => elm?.id === ProductCurrent?.sub_category_id,
      )[0];
      const CategoryCurrent = categorylistall?.filter(
        (elm) => elm?.id === GetCurrentSubCategory?.category_id,
      );
      const GetCurrentNewSubCategory = subCategorylistall?.filter(
        (elm) => elm?.id === ProductCurrent?.sub_category_id,
      );
      const ProductNewCurrent = productlistall?.filter(
        (elm) => elm?.id === value?.value,
      );
      setoptionsCategory(
        CategoryCurrent?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.category_name,
        })),
      );
      setoptionsSubCategory(
        GetCurrentNewSubCategory?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.sub_category_name,
        })),
      );
      setoptionsItemName(
        ProductNewCurrent?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.product_name,
        })),
      );
      setselectCategory(
        CategoryCurrent?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.category_name,
        }))[0],
      );
      setselectSubCategory(
        GetCurrentNewSubCategory?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.sub_category_name,
        }))[0],
      );
      setselectItemName(
        ProductNewCurrent?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.product_name,
        }))[0],
      );
      setFilterDisable(true);
    } else {
      setselectProduct("");
      setFilterDisable(false);
      setselectItemName(null);
      setselectSubCategory(null);
      setselectCategory(null);
      setoptionsSubCategory([]);
      setoptionsItemName([]);
      setoptionsCategory(
        categorylistall?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.category_name,
        })),
      );
    }
  };

  // Product select
  const BundlesSelect = (value) => {
    if (value !== null) {
      setselectBundlesItem(value);
    } else {
      setselectBundlesItem("");
    }
  };

  // category select
  const CategorySelect = (value) => {
    setselectSubCategory(null);
    setselectItemName(null);
    if (value !== null) {
      setselectCategory(value);
      const CategoryCurrent = categorylistall?.filter(
        (elm) => elm?.id === value?.value,
      )[0];
      const SubCategoryCurrent = subCategorylistall?.filter(
        (elm) => elm?.category_id === CategoryCurrent?.id,
      );
      const ProductCurrent = productlistall?.filter(
        (elm) => elm?.sub_category_id === SubCategoryCurrent?.id,
      );
      setoptionsSubCategory(
        SubCategoryCurrent?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.sub_category_name,
        })),
      );
      setoptionsItemName(
        ProductCurrent?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.product_name,
        })),
      );
    } else {
      setselectCategory("");
      setoptionsSubCategory([]);
      setoptionsItemName([]);
      setoptionsItemName([]);
    }
  };

  // sub category select
  const SubCategorySelect = (value) => {
    setselectItemName(null);
    if (value !== null) {
      setselectSubCategory(value);
      const SubCategoryCurrent = subCategorylistall?.filter(
        (elm) => elm?.id === value?.value,
      )[0];
      const ProductCurrent = productlistall?.filter(
        (elm) => elm?.sub_category_id === SubCategoryCurrent?.id,
      );
      setoptionsItemName(
        ProductCurrent?.map((item, index) => ({
          key: item.id,
          value: item?.id,
          label: item?.product_name,
        })),
      );
    } else {
      setselectSubCategory("");
    }
  };

  const ItemSelect = (value) => {
    if (value !== null) {
      setselectItemName(value);
    } else {
      setselectItemName("");
    }
  };

  // select franchise delivery address
  const selectFranchiseDeliveryAddress = (value) => {
    if (value !== null) {
      setFranchiseDealerAddress(value);
      if (value?.customer_name === "Other") {
        seterrorGSTIN(``);
      }
    } else {
      setFranchiseDealerAddress("");
    }
  };

  // search pincode
  const onEnterPincodeSearch = (e) => {
    const code = e.which || e.keyCode;
    if (code === 13) {
      SearchPincode();
    }
  };

  // search pincode
  const SearchPincode = () => {
    if (ApplicationState?.PINCode?.length === 6) {
      Dispatch(StartCommonLoader(true));
      let param = {
        transmit: "broadcast",
        url: "pin_code_search",
        request: {
          pin_code: ApplicationState?.PINCode,
        },
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    } else {
      Dispatch(StartCommonLoader(false));
    }
  };

  const PinCOdeSearchFunction = (e) => {
    setApplicationState({ ...ApplicationState, PINCode: e.target.value });
    if (e.target.value.length === 6) {
      Dispatch(StartCommonLoader(true));
      let param = {
        transmit: "broadcast",
        url: "pin_code_search",
        request: {
          pin_code: e.target.value,
        },
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    }
    if (e.target.value === "") {
      Dispatch(SearchPincodeList({}));
      Dispatch(
        ErrorMessageFromRedux({
          API: "",
          Error: "",
        }),
      );
    } else {
      Dispatch(StartCommonLoader(false));
    }
  };

  const [ProductListOrder, setProductListOrder] = useState([]);
  var ProductMergAarray = [...ProductListOrder];

  function generateRandomId() {
    // Generate a random number
    const randomNumber = Math.floor(Math.random() * 10000);

    // Get the current timestamp
    const timestamp = new Date().getTime();

    // Concatenate the random number and timestamp to create the ID
    const randomId = `${timestamp}-${randomNumber}`;

    return randomId;
  }

  const [sparesProductWiseQtyMain, setsparesProductWiseQtyMain] = useState([]);
  let sparesProductWiseQty = [...sparesProductWiseQtyMain];
  // add purchase order
  const PurchaseOrderAdd = () => {
    if (PermissionStockInwardModule?.permissionStockInward === "Bundles") {
      const GetCurrentBundles = bundlesItemAllList?.bundle_items?.filter(
        (elm) => elm?.bundle_id === selectBundlesItem?.id,
      );
      const AddGetCurrentBundles = GetCurrentBundles?.map((elm) => {
        const GetCurrentPorduct = optionsProducts?.filter(
          (elmss) => elmss?.product_code === elm?.product_code,
        )[0];
        return {
          id: elm?.id,
          product: GetCurrentPorduct,
          quantity: parseInt(elm?.qty),
          is_demo: false,
        };
      });

      setselectParentBundlesItem(selectBundlesItem?.parent_id);
      setProductListOrder(AddGetCurrentBundles);
      // PurchaseOrderClear();
    } else if (
      PermissionStockInwardModule?.permissionStockInward === "Spares"
    ) {
      if (
        selectFranchise !== "" &&
        sparesCampatProduct !== "" &&
        selectProduct !== "" &&
        AddQuantity > 0
      ) {
        let Obj = {
          id: generateRandomId(),
          spares_campat_item_code: sparesCampatProduct,
          compatible_item_name: sparesCampatProduct?.compatible_item_name,
          franchise: selectFranchise,
          product: selectProduct,
          sub_category: selectSubCategory,
          category: selectCategory,
          rate: GetCurrentOrderRate({ is_demo: false }, selectProduct)?.price,
          sub_total: GetCurrentOrderRate(
            { is_demo: false, quantity: parseInt(AddQuantity) },
            selectProduct,
          )?.sub_total,
          quantity: parseInt(AddQuantity),
        };

        let sparesProducts = {
          id: sparesCampatProduct.id,
          compatible_item_name: sparesCampatProduct.compatible_item_name,
          quantity: parseInt(AddQuantity),
        };
        sparesProductWiseQty.push(sparesProducts);

        let mergesparesItems = mergeAndUpdateSpares(sparesProductWiseQty);
        setsparesProductWiseQtyMain(mergesparesItems);

        if (GetCurrentDealerFranchiseType?.is_flexible_pricing) {
          Obj.amount = parseInt(AddRate);
        }

        ProductMergAarray?.push(Obj);

        let mergedArray = mergeAndUpdate(ProductMergAarray);
        // unique array convert

        const UpdateProductListOrder = mergedArray?.map((elm) => {
          const compatible_items = elm?.compatible_item_name?.split(",");

          const getSparesQty = (spare_qty) => {
            const getCurrentSPres = mergesparesItems?.filter(
              (elm) => elm?.compatible_item_name === spare_qty?.trim(),
            )[0];
            return getCurrentSPres;
          };

          return {
            ...elm,
            compatible_items: compatible_items?.map((elmx, index) => {
              return {
                id: getSparesQty(elmx)?.id,
                item_id: elm?.id,
                compatible_item_name: elmx,
                quantity: getSparesQty(elmx)?.quantity,
              };
            }),
          };
        });

        setProductListOrder(UpdateProductListOrder);
        PurchaseOrderClear();
      } else {
      }
    } else {
      if (
        selectFranchise !== "" &&
        selectProduct !== "" &&
        selectSubCategory !== "" &&
        selectCategory !== "" &&
        AddQuantity > 0
      ) {
        if (
          selectProduct?.basket_height ||
          selectProduct?.basket_length ||
          selectProduct?.basket_weight ||
          selectProduct?.basket_width
        ) {
          if (parseInt(AddQuantity) < 2 || parseInt(AddQuantity) % 2 !== 0) {
            toast.error("Minimum order quantity is 2 and it must be even");
            return;
          }
        }
        let Obj = {
          id: generateRandomId(),
          franchise: selectFranchise,
          product: selectProduct,
          sub_category: selectSubCategory,
          category: selectCategory,
          quantity: parseInt(AddQuantity),
          is_demo: IsDemo,
        };

        if (GetCurrentDealerFranchiseType?.is_flexible_pricing) {
          Obj.amount = parseInt(AddRate);
        }

        ProductMergAarray?.push(Obj);

        let mergedArray = mergeAndUpdate(ProductMergAarray);
        // unique array convert
        setProductListOrder(mergedArray);
        PurchaseOrderClear();
      } else {
      }
    }
  };

  // merge array and add quantity
  function mergeAndUpdate(arr) {
    let mergedArray = [];
    arr.forEach((item) => {
      // Check if the item already exists in the merged array
      const existingSparesItemIndex = mergedArray.findIndex(
        (mergedItem) =>
          mergedItem?.spares_campat_item_code?.primary_item_code ===
          item?.spares_campat_item_code?.primary_item_code,
      );

      const existingItemIndex = mergedArray.findIndex(
        (mergedItem) =>
          mergedItem?.product?.value === item?.product?.value &&
          mergedItem.is_demo === item.is_demo,
      );

      if (PermissionStockInwardModule?.permissionStockInward === "Spares") {
        if (existingSparesItemIndex !== -1) {
          // If the item exists, update its quantity
          mergedArray[existingSparesItemIndex].quantity += item.quantity;

          const compatible_item_name_array = mergedArray[
            existingSparesItemIndex
          ].compatible_item_name
            ?.split(",")
            ?.map((elm) => {
              return elm?.trim();
            });

          if (
            !compatible_item_name_array.includes(
              item?.spares_campat_item_code?.compatible_item_name,
            )
          ) {
            mergedArray[existingSparesItemIndex].compatible_item_name +=
              ", " + item?.spares_campat_item_code?.compatible_item_name;
          }
        } else {
          // If the item doesn't exist, add it to the merged array
          mergedArray.push({ ...item });
        }
      } else {
        if (existingItemIndex !== -1) {
          // If the item exists, update its quantity
          mergedArray[existingItemIndex].quantity += item.quantity;
        } else {
          // If the item doesn't exist, add it to the merged array
          mergedArray.push({ ...item });
        }
      }
    });

    return mergedArray;
  }

  // merge spares array
  function mergeAndUpdateSpares(arr) {
    let mergedArray = [];
    arr.forEach((item) => {
      // Check if the item already exists in the merged array
      const existingItemIndex = mergedArray.findIndex(
        (mergedItem) => mergedItem?.id === item?.id,
      );

      if (existingItemIndex !== -1) {
        // If the item exists, update its quantity
        mergedArray[existingItemIndex].quantity += item.quantity;
      } else {
        // If the item doesn't exist, add it to the merged array
        mergedArray.push({ ...item });
      }
    });

    return mergedArray;
  }

  // Function to handle adding quantity
  const addMainQuantity = (id) => {
    const AddQauntArray = ProductMergAarray?.map((elm) => {
      if (elm?.id === id) {
        if (
          elm?.product?.basket_height ||
          elm?.product?.basket_length ||
          elm?.product?.basket_weight ||
          elm?.product?.basket_width
        ) {
          return {
            ...elm,
            quantity: parseInt(elm?.quantity) + 2,
          };
        }
        return {
          ...elm,
          quantity: parseInt(elm?.quantity) + 1,
        };
      } else {
        return elm;
      }
    });
    setProductListOrder(AddQauntArray);
  };

  // Function to handle removing quantity
  const removeQuantity = (id, value) => {
    const updated = ProductMergAarray?.map((elm) => {
      if (elm?.id !== id) return elm;

      const qty = parseInt(elm?.quantity);

      const isBasket =
        elm?.product?.basket_height ||
        elm?.product?.basket_length ||
        elm?.product?.basket_weight ||
        elm?.product?.basket_width;

      if (!isBasket && qty <= 1) return elm;
      if (isBasket && qty <= 2) return elm;

      return {
        ...elm,
        quantity: isBasket ? qty - 2 : qty - 1,
      };
    }).filter(Boolean);

    setProductListOrder(updated);
  };

  const GetPcCodeWiseItems = (data) => {
    const mergedData = data.reduce((acc, current) => {
      const existing = acc.find(
        (item) => item.product.product_code === current.product.product_code,
      );

      if (existing) {
        // Merge quantities
        existing.quantity += current.quantity;

        // Merge compatible items
        current?.compatible_items?.forEach((newItem) => {
          const existingItem = existing.compatible_items.find(
            (item) => item.id === newItem.id,
          );
          if (existingItem) {
            existingItem.quantity += newItem.quantity;
          } else {
            existing.compatible_items.push(newItem);
          }
        });
      } else {
        // Add new item if not already present
        acc.push({ ...current });
      }

      return acc;
    }, []);

    return mergedData;
  };

  const PrviewOrderCarts = () => {
    if (PermissionStockInwardModule?.permissionStockInward === "Spares") {
      let sparesItems = GetPcCodeWiseItems(ProductListOrder);
      let greaterRateOfproduct = sparesItems.reduce((max, current) =>
        parseFloat(max?.product?.igst_rate) >
        parseFloat(current?.product?.igst_rate)
          ? max
          : current,
      );
      let GreaterGstTransporationChargesProduct =
        optionsProductsTransportation?.filter(
          (elm) =>
            parseFloat(elm?.igst_rate) ===
            parseFloat(greaterRateOfproduct?.product?.igst_rate),
        )[0];

      let Obj = {
        id: generateRandomId(),
        spares_campat_item_code: [],
        compatible_item_name: {},
        franchise: selectFranchise,
        product: GreaterGstTransporationChargesProduct,
        sub_category: selectSubCategory,
        category: selectCategory,
        rate: GetCurrentOrderRate(
          { is_demo: false },
          GreaterGstTransporationChargesProduct,
        )?.price,
        sub_total: GetCurrentOrderRate(
          { is_demo: false, quantity: 1 },
          GreaterGstTransporationChargesProduct,
        )?.sub_total,
        quantity: 1,
      };
      sparesItems?.push(Obj);
      setProductListOrder(sparesItems);
    }
    setPreviewOrder(!PreviewOrder);
  };

  // confirm order
  const PhoneCode = 91;
  const CountryStates = getRegionCodeForCountryCode(PhoneCode);
  const CheckMobileNumber = parsePhoneNumber(
    ApplicationState?.Mobile?.toString(),
    { regionCode: CountryStates },
  );

  const isSearchPincodeListEmpty =
    Object?.keys(searchPincodeList?.pin)?.length === 0 &&
    Object?.keys(searchPincodeList?.state)?.length === 0 &&
    Object?.keys(searchPincodeList?.city)?.length === 0;

  const ConfirmOrder = () => {
    const ProductListOrderStateArray = [];
    const sparesItems = GetPcCodeWiseItems(ProductListOrder);

    if (DistributorAllow) {
      ProductListOrder?.filter((elm, index) => {
        return ProductListOrderStateArray?.push({
          product_id: elm?.product?.id,
          product_qty: elm?.quantity,
          is_demo: elm?.is_demo,
          amount: elm?.amount,
          rate: elm?.rate,
          idx: index + 1,
        });
      });
    } else {
      if (PermissionStockInwardModule?.permissionStockInward === "Spares") {
        sparesItems?.filter((elm, index) => {
          return ProductListOrderStateArray?.push({
            product_id: elm?.product?.id,
            product_qty: elm?.quantity,
            is_demo: false,
            rate: elm?.rate,
            idx: index + 1,
          });
        });
      } else {
        ProductListOrder?.filter((elm, index) => {
          return ProductListOrderStateArray?.push({
            product_id: elm?.product?.id,
            product_qty: elm?.quantity,
            is_demo: elm?.is_demo,
            amount: elm?.amount,
            idx: index + 1,
          });
        });
      }
    }

    if (
      ApplicationState?.Name.trim() !== "" &&
      ApplicationState?.Mobile.trim() !== "" &&
      ApplicationState?.Email.trim() !== "" &&
      ApplicationState?.PINCode.trim() !== "" &&
      ApplicationState?.Address.trim() !== "" &&
      ApplicationState?.address2?.length <= 100 &&
      ApplicationState?.Address.length <= 100 &&
      !isSearchPincodeListEmpty
    ) {
      if (
        EmailRegex.test(ApplicationState?.Email.trim()) === true &&
        CheckMobileNumber?.valid === true &&
        pinRegex?.test(ApplicationState?.PINCode.trim()) === true
      ) {
        Dispatch(
          StartMainCommonLoader({
            url: "order_add",
            loader: true,
          }),
        );

        let param = {
          transmit: "broadcast",
          url:
            PermissionStockInwardModule?.permissionStockInward === "Spares"
              ? "afs_order_add"
              : "order_add",
          request: {
            order_type: "FO",
            shipping_id: FranchiseDealerAddress?.value,
            billing_id: selectFranchise,
            items: ProductListOrderStateArray,
            remark: ApplicationState?.Remark.trim(),
            pre_book: IsPreOrder,
            // "is_pin_same":true,
          },
          DeviceId: device_id,
        };

        if (PermissionStockInwardModule?.permissionStockInward === "Spares") {
          ((param.request.ship_customer_name = ApplicationState?.Name.trim()),
            (param.request.ship_email = ApplicationState?.Email.trim()),
            (param.request.ship_mobile = ApplicationState?.Mobile.trim()),
            (param.request.ship_pin_code_id = searchPincodeList?.pin?.id),
            (param.request.ship_pan_no = ApplicationState?.PANCard.trim()),
            (param.request.ship_gstin_no = ApplicationState?.GSTIN.trim()),
            (param.request.ship_address = ApplicationState?.Address.trim()),
            (param.request.ship_address2 = ApplicationState?.address2),
            (param.request.sale_type = optionSaleTypeAllList?.label),
            (param.request.sale_type_id = optionSaleTypeAllList?.value));
        } else {
          ((param.request.customer_name = ApplicationState?.Name.trim()),
            (param.request.mobile = ApplicationState?.Mobile.trim()),
            (param.request.email = ApplicationState?.Email.trim()),
            (param.request.pin_code_id = searchPincodeList?.pin?.id),
            (param.request.pan_no = ApplicationState?.PANCard.trim()),
            (param.request.gstin_no = ApplicationState?.GSTIN.trim()),
            (param.request.address = ApplicationState?.Address.trim()),
            (param.request.address2 = ApplicationState?.address2?.trim()));
        }
        if (PermissionStockInwardModule?.permissionStockInward === "Bundles") {
          ((param.request.customer_name = ApplicationState?.Name.trim()),
            (param.request.mobile = ApplicationState?.Mobile.trim()),
            (param.request.email = ApplicationState?.Email.trim()),
            (param.request.pin_code_id = searchPincodeList?.pin?.id),
            (param.request.pan_no = ApplicationState?.PANCard.trim()),
            (param.request.gstin_no = ApplicationState?.GSTIN.trim()),
            (param.request.address = ApplicationState?.Address.trim()),
            (param.request.address2 = ApplicationState?.address2?.trim()),
            (param.request.bundle_parent_id = selectParentBundlesItem));
        }

        if (DistributorAllow) {
          param.request.isdistributor_order = true;
        }

        wsSend_request(websocket, param);
      } else {
        CheckValid(ApplicationState?.Mobile.trim(), {
          type: "phone",
          error: seterrorMobile,
        });
        CheckValid(ApplicationState?.Email.trim(), {
          type: "email",
          error: seterrorEmail,
        });
        CheckValid(ApplicationState?.PINCode.trim(), {
          type: "PINCode",
          error: seterrorPINCode,
        });
      }
    } else {
      CheckValid(ApplicationState?.Name.trim(), {
        type: "Customername",
        error: seterrorName,
      });
      CheckValid(ApplicationState?.Mobile.trim(), {
        type: "phone",
        error: seterrorMobile,
      });
      CheckValid(ApplicationState?.PINCode.trim(), {
        type: "PINCode",
        error: seterrorPINCode,
      });
      CheckValid(ApplicationState?.Email.trim(), {
        type: "email",
        error: seterrorEmail,
      });
      CheckValid(ApplicationState?.Address.trim(), {
        type: "Address",
        error: seterrorAddress,
      });
      CheckValid(ApplicationState?.address2?.trim(), {
        type: "address2",
        error: seterrorAddress2,
      });
    }
  };

  const OrderPurchaseFunct = () => {
    let transportationChargesRatting = ProductListOrder?.filter(
      (elm) => elm?.product?.custom_is_transportation,
    )[0]?.rate;
    if (PermissionStockInwardModule?.permissionStockInward === "Spares") {
      if (transportationChargesRatting !== "") {
        CommonFunctionOrderCreations();
      } else {
        toast.error("Please add the transportation charge rate.");
      }
    } else {
      CommonFunctionOrderCreations();
    }
  };

  const CommonFunctionOrderCreations = () => {
    if (FranchiseDealerAddress?.customer_name === "Other") {
      if (
        ApplicationState?.Name.trim() !== "" &&
        ApplicationState?.Mobile.trim() !== "" &&
        ApplicationState?.Email.trim() !== "" &&
        ApplicationState?.PINCode.trim() !== "" &&
        !isSearchPincodeListEmpty &&
        ApplicationState?.Address.trim() !== "" &&
        ApplicationState?.address2?.length <= 100 &&
        ApplicationState?.Address.length <= 100
      ) {
        if (
          EmailRegex.test(ApplicationState?.Email.trim()) === true &&
          CheckMobileNumber?.valid === true &&
          pinRegex?.test(ApplicationState?.PINCode.trim()) === true
        ) {
          setShowModalNew({
            ...showModalNew,
            open: open,
            title: "Confirmation",
            subtitle: "Order-Purchase",
            modalType: "Order-Purchase",
            description: "Are you sure to proceed for Order?",
            modalType: "not form",
            button: "Yes",
            Data: {},
          });
        } else {
          CheckValid(ApplicationState?.Mobile.trim(), {
            type: "phone",
            error: seterrorMobile,
          });
          CheckValid(ApplicationState?.Email.trim(), {
            type: "email",
            error: seterrorEmail,
          });
          CheckValid(ApplicationState?.PINCode.trim(), {
            type: "PINCode",
            error: seterrorPINCode,
          });
        }
      } else {
        CheckValid(ApplicationState?.Name.trim(), {
          type: "Customername",
          error: seterrorName,
        });
        CheckValid(ApplicationState?.Mobile.trim(), {
          type: "phone",
          error: seterrorMobile,
        });
        CheckValid(ApplicationState?.PINCode.trim(), {
          type: "PINCode",
          error: seterrorPINCode,
        });
        CheckValid(ApplicationState?.Email.trim(), {
          type: "email",
          error: seterrorEmail,
        });
        CheckValid(ApplicationState?.Address.trim(), {
          type: "Address",
          error: seterrorAddress,
        });
        CheckValid(ApplicationState?.address2?.trim(), {
          type: "address2",
          error: seterrorAddress2,
        });
      }
    } else {
      if (ApplicationState?.GSTIN.trim() !== "") {
        if (
          ApplicationState?.Name.trim() !== "" &&
          ApplicationState?.Mobile.trim() !== "" &&
          ApplicationState?.Email.trim() !== "" &&
          ApplicationState?.PINCode.trim() !== "" &&
          !isSearchPincodeListEmpty &&
          ApplicationState?.Address.trim() !== "" &&
          ApplicationState?.address2?.length <= 100 &&
          ApplicationState?.Address.length <= 100
        ) {
          if (
            EmailRegex.test(ApplicationState?.Email.trim()) === true &&
            CheckMobileNumber?.valid === true &&
            pinRegex?.test(ApplicationState?.PINCode.trim()) === true &&
            GSTvalidations(ApplicationState?.GSTIN) &&
            ApplicationState?.GSTIN?.length === 15
          ) {
            setShowModalNew({
              ...showModalNew,
              open: open,
              title: "Confirmation",
              subtitle: "Order-Purchase",
              modalType: "Order-Purchase",
              description: "Are you sure to proceed for Order?",
              modalType: "not form",
              button: "Yes",
              Data: {},
            });
          } else {
            CheckValid(ApplicationState?.Mobile.trim(), {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            CheckValid(ApplicationState?.PINCode.trim(), {
              type: "PINCode",
              error: seterrorPINCode,
            });
            if (
              GSTvalidations(ApplicationState?.GSTIN) &&
              ApplicationState?.GSTIN?.length === 15
            ) {
              seterrorGSTIN("");
            } else {
              seterrorGSTIN(
                `Please enter a valid GSTIN number. GST numbers must begin with the prefix '${
                  searchPincodeList?.state?.gst_code?.length === 1
                    ? String(searchPincodeList?.state?.gst_code).padStart(
                        2,
                        "0",
                      )
                    : searchPincodeList?.state?.gst_code
                }'.`,
              );
            }
          }
        } else {
          CheckValid(ApplicationState?.Name.trim(), {
            type: "Customername",
            error: seterrorName,
          });
          CheckValid(ApplicationState?.Mobile.trim(), {
            type: "phone",
            error: seterrorMobile,
          });
          CheckValid(ApplicationState?.PINCode.trim(), {
            type: "PINCode",
            error: seterrorPINCode,
          });
          CheckValid(ApplicationState?.Email.trim(), {
            type: "email",
            error: seterrorEmail,
          });
          CheckValid(ApplicationState?.Address.trim(), {
            type: "Address",
            error: seterrorAddress,
          });
          CheckValid(ApplicationState?.address2?.trim(), {
            type: "address2",
            error: seterrorAddress2,
          });
          if (ApplicationState?.GSTIN.trim() !== "") {
            if (searchPincodeList?.state?.gst_code === undefined) {
              seterrorGSTIN(
                `Before you enter the GSTIN number, please enter the PIN code.`,
              );
            } else {
              if (
                GSTvalidations(ApplicationState?.GSTIN) &&
                ApplicationState?.GSTIN?.length === 15
              ) {
                seterrorGSTIN("");
              } else {
                seterrorGSTIN(
                  `Please enter a valid GSTIN number. GST numbers must begin with the prefix '${
                    searchPincodeList?.state?.gst_code?.length === 1
                      ? String(searchPincodeList?.state?.gst_code).padStart(
                          2,
                          "0",
                        )
                      : searchPincodeList?.state?.gst_code
                  }'.`,
                );
              }
            }
          } else {
            // seterrorGSTIN("GSTIN cannot be empty");
          }
        }
      } else {
        if (
          ApplicationState?.Name.trim() !== "" &&
          ApplicationState?.Mobile.trim() !== "" &&
          ApplicationState?.Email.trim() !== "" &&
          ApplicationState?.PINCode.trim() !== "" &&
          !isSearchPincodeListEmpty &&
          ApplicationState?.Address.trim() !== "" &&
          ApplicationState?.address2?.length <= 100 &&
          ApplicationState?.Address.length <= 100
        ) {
          if (
            EmailRegex.test(ApplicationState?.Email.trim()) === true &&
            CheckMobileNumber?.valid === true &&
            pinRegex?.test(ApplicationState?.PINCode.trim()) === true
          ) {
            setShowModalNew({
              ...showModalNew,
              open: open,
              title: "Confirmation",
              subtitle: "Order-Purchase",
              modalType: "Order-Purchase",
              description: "Are you sure to proceed for Order?",
              modalType: "not form",
              button: "Yes",
              Data: {},
            });
          } else {
            CheckValid(ApplicationState?.Mobile.trim(), {
              type: "phone",
              error: seterrorMobile,
            });
            CheckValid(ApplicationState?.Email.trim(), {
              type: "email",
              error: seterrorEmail,
            });
            CheckValid(ApplicationState?.PINCode.trim(), {
              type: "PINCode",
              error: seterrorPINCode,
            });
          }
        } else {
          CheckValid(ApplicationState?.Name.trim(), {
            type: "Customername",
            error: seterrorName,
          });
          CheckValid(ApplicationState?.Mobile.trim(), {
            type: "phone",
            error: seterrorMobile,
          });
          CheckValid(ApplicationState?.PINCode.trim(), {
            type: "PINCode",
            error: seterrorPINCode,
          });
          CheckValid(ApplicationState?.Email.trim(), {
            type: "email",
            error: seterrorEmail,
          });
          CheckValid(ApplicationState?.Address.trim(), {
            type: "Address",
            error: seterrorAddress,
          });
          CheckValid(ApplicationState?.address2?.trim(), {
            type: "address2",
            error: seterrorAddress2,
          });
        }
      }
    }
  };

  // clear purchase order
  const PurchaseOrderClear = () => {
    setSparesCampatProduct("");
    setselectBundlesItem("");
    setselectProduct("");
    setselectSubCategory("");
    setselectCategory("");
    setIsDemo(false);
    setAddQuantity("");
    setAddRate("");
    setFilterDisable(false);
    setoptionsSubCategory([]);
    setoptionsItemName([]);
    setselectItemName("");
    setoptionsCategory(() =>
      categorylistall?.map((item, index) => ({
        key: item.id,
        value: item?.id,
        label: item?.category_name,
      })),
    );
  };

  // bundles all clear
  const PurchaseBundlesOrderClear = () => {
    setSparesCampatProduct("");
    setselectBundlesItem("");
    setselectProduct("");
    setselectSubCategory("");
    setselectCategory("");
    setIsDemo(false);
    setAddQuantity("");
    setAddRate("");
    setFilterDisable(false);
    setoptionsSubCategory([]);
    setoptionsItemName([]);
    setselectItemName("");
    setoptionsCategory(() =>
      categorylistall?.map((item, index) => ({
        key: item.id,
        value: item?.id,
        label: item?.category_name,
      })),
    );
    setProductListOrder([]);
    setoptionsItemName([]);
  };

  // all clears data
  const PurchaseOrderMainClear = () => {
    setselectBundlesItem("");
    setsparesProductWiseQtyMain("");
    setSparesCampatProduct("");
    setselectFranchise("");
    setIsPreOrder(false);
    setselectProduct("");
    setselectSubCategory("");
    setselectCategory("");
    setIsDemo(false);
    setAddQuantity("");
    setAddRate("");
    setProductListOrder([]);
    setFilterDisable(false);
    setFranchiseDealerAddress("");
    setoptionsSubCategory([]);
    setoptionsItemName([]);
    setselectItemName("");
    setoptionsCategory(() =>
      categorylistall?.map((item, index) => ({
        key: item.id,
        value: item?.id,
        label: item?.category_name,
      })),
    );
  };

  useEffect(() => {
    if (ClearFormSet?.action === 200 && ClearFormSet?.url === "order_add") {
      setselectParentBundlesItem("");
      PurchaseOrderClear();
      PurchaseOrderMainClear();
      setApplicationState({
        ...ApplicationState,
        Name: "",
        Mobile: "",
        Email: "",
        PINCode: "",
        PANCard: "",
        GSTIN: "",
        Address: "",
        address2: "",
      });
      setSparesCampatProduct("");
    }
  }, [ClearFormSet]);

  useEffect(() => {
    setselectParentBundlesItem("");
    PurchaseOrderClear();
    PurchaseOrderMainClear();
    setApplicationState({
      ...ApplicationState,
      Name: "",
      Mobile: "",
      Email: "",
      PINCode: "",
      PANCard: "",
      GSTIN: "",
      Address: "",
      address2: "",
    });
    setSparesCampatProduct("");
    setPreviewOrder(false);
  }, [DistributorAllow]);

  function getGstAmt(price, gstRate) {
    return (
      parseFloat(price) - parseFloat(price) / (1 + parseFloat(gstRate) / 100)
    );
  }

  // gst get
  const GetGSTAmount = () => {
    let total = 0;
    let total_gst = 0;
    let price = 0;
    let sub_total = 0;
    ProductListOrder?.filter((elm) => {
      const ProductGet = productlistall?.filter((elms) => {
        if (
          PermissionStockInwardModule?.permissionStockInward === "Bundles" &&
          PermissionStockInwardModule?.permissionStockInward !== "Spares"
        ) {
          return elms?.id === elm?.product?.value;
        } else {
          return elms?.id === elm?.product?.id;
        }
      })[0];

      if (DistributorAllow) {
        if (elm?.is_demo) {
          price = ProductGet?.demo_rate;
        } else {
          price = ProductGet?.distributor_rate;
        }
      } else {
        if (elm?.is_demo) {
          price = ProductGet?.demo_rate;
        } else {
          price = ProductGet?.franchise_rate;
        }
      }

      let gst_rate = ProductGet?.igst_rate;

      sub_total = parseFloat(parseFloat(price) * parseInt(elm?.quantity) * 100);
      total = total + sub_total;
      // total_gst = parseInt(total_gst + (parseInt((parseInt(gst_rate) / 100) * sub_total)));
      total_gst =
        total_gst + getGstAmt(price, gst_rate) * parseInt(elm?.quantity);
    });

    return {
      total: total / 100,
      total_gst: total_gst,
    };
  };

  const GetCurrentOrderRate = (current, product) => {
    let price = 0;
    let sub_total = 0;

    if (DistributorAllow) {
      if (current?.is_demo) {
        price = parseFloat(
          product?.demo_rate === null ? 0 : product?.demo_rate,
        );
      } else {
        price = parseFloat(
          product?.distributor_rate === null ? 0 : product?.distributor_rate,
        );
      }
    } else {
      if (current?.is_demo) {
        price = parseFloat(
          product?.demo_rate === null ? 0 : product?.demo_rate,
        );
      } else {
        price = parseFloat(
          product?.franchise_rate === null ? 0 : product?.franchise_rate,
        );
      }
    }

    sub_total = parseFloat(
      parseFloat(price) * parseFloat(current?.quantity) * 100,
    );

    return {
      price: price,
      sub_total: sub_total / 100,
    };
  };

  const GSTvalidations = (value) => {
    if (value !== "") {
      const GSTDigit =
        searchPincodeList?.state?.gst_code?.length === 1
          ? 2
          : searchPincodeList?.state?.gst_code?.length;
      const GSTDigitValid =
        searchPincodeList?.state?.gst_code?.length === 1
          ? String(searchPincodeList?.state?.gst_code).padStart(2, "0")
          : searchPincodeList?.state?.gst_code;

      const Substring = value.trim().substring(0, GSTDigit);

      if (Substring.toString() === GSTDigitValid.toString()) {
        return true;
      } else {
        return false;
      }
    }
  };

  const GSTINvalidKeyUp = (value) => {
    if (value !== "") {
      if (searchPincodeList?.state?.gst_code === undefined) {
        seterrorGSTIN(
          `Before you enter the GST number, please enter the PIN code.`,
        );
      } else {
        if (GSTvalidations(value) && value?.length === 15) {
          seterrorGSTIN("");
        } else {
          seterrorGSTIN(
            `Please enter a valid GSTIN number. GST numbers must begin with the prefix '${
              searchPincodeList?.state?.gst_code?.length === 1
                ? String(searchPincodeList?.state?.gst_code).padStart(2, "0")
                : searchPincodeList?.state?.gst_code
            }'.`,
          );
        }
      }
    } else {
      // seterrorGSTIN("GSTIN cannot be empty");
    }
  };

  useEffect(() => {
    if (!PreviewOrder) {
      setApplicationState((prevState) => ({
        ...prevState,
        Remark: "",
      }));
    }
  }, [PreviewOrder]);

  useEffect(() => {
    if (ClearFormSet?.action === 200) {
      setselectParentBundlesItem("");
      setShowModalNew({
        ...showModalNew,
        open: false,
        Data: {},
      });
      setPreviewOrder(false);
    }
  }, [ClearFormSet]);

  const DisableAddButton = GetCurrentDealerFranchiseType?.is_flexible_pricing
    ? AddRate > 0 &&
      selectFranchise !== "" &&
      selectProduct !== "" &&
      selectSubCategory !== "" &&
      selectCategory !== "" &&
      AddQuantity > 0
    : selectFranchise !== "" &&
      selectProduct !== "" &&
      selectSubCategory !== "" &&
      selectCategory !== "" &&
      AddQuantity > 0;

  const onChange = (e) => {
    let value = e.target.value;

    if (value?.length < 16) {
      // Remove leading zeros
      value = value.replace(/^0+/g, "");

      // Remove non-numeric characters
      value = value.replace(/\D/g, "");

      // Ensure the value is more than 1 (not negative number)
      if (value === "" || parseInt(value) < 0) {
        value = ""; // Set default value to 1
      }

      // Update the state with the modified value
      setAddQuantity(parseInt(value));
    }
  };

  const onChangeRate = (e) => {
    let value = e.target.value;

    // Remove leading zeros
    value = value.replace(/^0+/g, "");

    // Remove non-numeric characters
    value = value.replace(/\D/g, "");

    // Ensure the value is more than 1 (not negative number)
    if (value === "" || parseInt(value) < 0) {
      value = ""; // Set default value to 1
    }

    // Update the state with the modified value
    setAddRate(parseInt(value));
  };

  document.addEventListener("wheel", function (event) {
    if (
      document.activeElement.type === "number" &&
      document.activeElement.classList.contains("inputBoxs")
    ) {
      document.activeElement.blur();
    }
  });

  // get spares product wise quantity
  const GetSparesProductList = (spares) => {
    return (
      <Table style={{ margin: "0px" }} bordered>
        <thead>
          <tr>
            <th>Compatible Item Name</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          {spares
            ?.filter((elm) => {
              if (elm?.quantity !== undefined) {
                return elm;
              }
            })
            .map((elm, index, spares_array) => {
              return (
                <tr key={index}>
                  <td>{elm?.compatible_item_name}</td>
                  <td>
                    {PreviewOrder ? (
                      elm?.quantity
                    ) : (
                      <div className="QauntityManage">
                        <button
                          className="btn remove"
                          onClick={() =>
                            spares_array?.length === 1 && elm?.quantity === 1
                              ? DeleteOrder(elm?.item_id)
                              : removeSparesQuantity(
                                  elm?.id,
                                  elm?.quantity,
                                  elm?.item_id,
                                )
                          }
                        >
                          <i className="bi bi-dash-circle-fill"></i>
                        </button>
                        <h2>{elm?.quantity}</h2>
                        <button
                          className="btn add"
                          onClick={() =>
                            addMainSparesQuantity(elm?.id, elm?.item_id)
                          }
                        >
                          <i className="bi bi-plus-circle-fill"></i>
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    );
  };

  // Function to handle adding quantity
  const addMainSparesQuantity = (id, item_id) => {
    const AddQauntArray = ProductListOrder?.map((elm) => {
      if (elm?.id === item_id) {
        return {
          ...elm,
          compatible_items: elm?.compatible_items?.map((el) => {
            if (el?.id === id) {
              return {
                ...el,
                quantity: parseInt(el?.quantity) + 1,
              };
            } else {
              return el;
            }
          }),
          quantity: parseInt(elm?.quantity) + 1,
        };
      } else {
        return elm;
      }
    });
    setProductListOrder(AddQauntArray);

    BackSpareQty(AddQauntArray);
  };

  // Function to handle removing quantity
  const removeSparesQuantity = (id, value, item_id) => {
    const RemovedQunty = ProductMergAarray?.map((elm) => {
      if (value === 1) {
        if (elm?.id === item_id) {
          return {
            ...elm,
            compatible_items: elm?.compatible_items
              ?.map((el) => {
                if (el?.id !== id) {
                  return el;
                }
              })
              ?.filter((elm) => elm !== undefined),
            quantity: parseInt(elm?.quantity) - 1,
          };
        } else {
          return elm;
        }
      } else {
        if (elm?.id === item_id) {
          return {
            ...elm,
            compatible_items: elm?.compatible_items?.map((el) => {
              if (el?.id === id) {
                return {
                  ...el,
                  quantity: parseInt(el?.quantity) - 1,
                };
              } else {
                return el;
              }
            }),
            quantity: parseInt(elm?.quantity) - 1,
          };
        } else {
          return elm;
        }
      }
    })?.filter((elm) => elm !== undefined);
    setProductListOrder(RemovedQunty);
    BackSpareQty(RemovedQunty);
  };

  // remove order
  const DeleteOrder = (id) => {
    const RemoveOrder = [];
    ProductMergAarray?.map((elm) => {
      if (elm?.id !== id) {
        return RemoveOrder.push(elm);
      }
    });
    setProductListOrder(RemoveOrder);

    if (PermissionStockInwardModule?.permissionStockInward === "Spares") {
      BackSpareQty(RemoveOrder);
    }
  };

  const BackSpareQty = (spares_array_deletations) => {
    spares_array_deletations.forEach((spare) => {
      const currentSparesArray = spare.compatible_items;

      if (Array.isArray(currentSparesArray)) {
        currentSparesArray.forEach((item1) => {
          // Find the matching item in array2 by id
          const item2 = sparesProductWiseQty.find(
            (item) => item.id === item1.id,
          );

          // If a matching item is found, update its quantity with the one from array1
          if (item2) {
            item2.quantity = item1.quantity;
          }
        });
      }
    });

    // Remove items in sparesProductWiseQty that do not have a matching id in spares_array_deletations
    sparesProductWiseQty = sparesProductWiseQty.filter((item2) =>
      spares_array_deletations.some((spare) =>
        spare.compatible_items.some((item1) => item1.id === item2.id),
      ),
    );

    setsparesProductWiseQtyMain(sparesProductWiseQty);
  };

  // CUSTOME TRANSPORTATION CHARGES RATING CHANGES
  const TransportationRatingCustom = (value, data) => {
    let inputValue = value;
    let ProductListOrderArray = ProductListOrder?.map((elm) => {
      if (elm?.id === data?.id) {
        // Check if the input is a valid number with up to 2 decimal places
        if (/^\d*\.?\d*$/.test(inputValue)) {
          // Limit to 2 decimal places if there's a decimal point
          const [integerPart, decimalPart] = inputValue.split(".");
          if (decimalPart?.length > 2) {
            inputValue = `${integerPart}.${decimalPart.slice(0, 2)}`;
          }
          return {
            ...elm,
            rate: inputValue,
            sub_total: parseFloat(
              parseFloat(inputValue) * parseFloat(data?.quantity),
            ),
          };
        }
      } else {
        return elm;
      }
    });
    setProductListOrder(ProductListOrderArray);
  };

  const BackFunction = () => {
    if (PermissionStockInwardModule?.permissionStockInward === "Spares") {
      let ProductListOrderArray = ProductListOrder?.map((elm) => {
        if (!elm?.product?.custom_is_transportation) {
          return elm;
        }
      })?.filter((elm) => elm !== undefined);

      setProductListOrder(ProductListOrderArray);
    }
    setPreviewOrder(false);
    setFranchiseDealerAddress(FranchiseListStateVarsOptions[0]);
  };

  // GET CURRENT FRANCHISE AVAILABLE BALANCE SHOULD BE GREATER THAN THE TOTAL ORDER AMOUNT
  const GetCurrentTotalOrderAmount =
    ProductListOrder?.reduce((total, elm) => {
      if (PermissionStockInwardModule?.permissionStockInward === "Spares") {
        return (
          total +
          GetCurrentOrderRate(
            { is_demo: false, quantity: elm?.quantity },
            elm?.product,
          )?.sub_total
        );
      } else {
        return (
          total +
          GetCurrentOrderRate(
            { is_demo: elm?.is_demo, quantity: elm?.quantity },
            elm?.product,
          )?.sub_total
        );
      }
    }, 0) <= GetAvailableBalance()?.available_balance_parsFloat;

  // Standardized and shortened CheckAvailableBalanceModal
  const CheckAvailableBalanceModal = () => {
    const availableBalance = GetAvailableBalance()?.available_balance_parsFloat;
    const is90OS =
      Math.max(
        parseInt(erpAccountListSOrder?.list[0]?.range4) +
          parseInt(erpAccountListSOrder?.list[0]?.range5),
        0,
      ) >= 25000;
    let title =
      Math.max(
        parseInt(erpAccountListSOrder?.list[0]?.range4) +
          parseInt(erpAccountListSOrder?.list[0]?.range5),
        0,
      ) <= 25000
        ? "Balance Approval"
        : "Exceeded Outstanding Amount";
    let subtitle = "Order-Check-Available-Balance";
    let modalType = "Order-Check-Available-Balance";
    let button = "Yes";
    let functionNo = BackFunction;
    let description = "";

    // if (availableBalance < 0) {
    //   description = is90OS
    //     ? "The credit limit is completely utilised. <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
    //     : "The credit limit is completely utilised.";
    // } else if (GetCurrentTotalOrderAmount) {
    //   description = is90OS
    //     ? "Order value is under the credit limit. <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
    //     : "Order value is under the credit limit.";
    // } else {
    //   description = is90OS
    //     ? "Order value is exceeding the available credit limit. The order may get into rejection stages. <br/><span class='fw-bold text-danger'>Note: Please contact sales ops and accounts team for further clarity.</span><br/> <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
    //     : "Order value is exceeding the available credit limit. The order may get into rejection stages.<br/><span class='fw-bold text-danger'>Note: Please contact sales ops and accounts team for further clarity.</span>";
    // }

    if (availableBalance < 0) {
      description = is90OS
        ? "The credit limit is completely utilised. <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
        : "The credit limit is completely utilised.";
    } else if (GetCurrentTotalOrderAmount) {
      description = is90OS
        ? "Order value is under the credit limit. <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
        : "Order value is under the credit limit.";
    } else {
      description = is90OS
        ? "Order value is exceeding the available credit limit. The order may get into rejection stages. <br/><span class='fw-bold text-danger'>Note: Please contact sales ops and accounts team for further clarity.</span><br/> <span class='so_creation_erp_account'> Attention: Dealer under category of 90+OS.</span>"
        : "Order value is exceeding the available credit limit. The order may get into rejection stages.<br/><span class='fw-bold text-danger'>Note: Please contact sales ops and accounts team for further clarity.</span>";
    }

    setShowModalNew({
      ...showModalNew,
      open: open,
      title,
      subtitle,
      modalType,
      description,
      modalType: "not form",
      button,
      functionNo,
      Data: {},
    });
  };
  return (
    <section className="Main_section">
      {!PreviewOrder && (
        <div
          className="filtr_Form Purchase_Order_Mendetory"
          style={{ borderBottom: "1px solid #eee" }}
        >
          {GetCurrentDealerFranchiseType === undefined ? (
            <div className="formloginset">
              <div className="row">
                <div className="col-md-3" style={{ width: "19%" }}>
                  <div className="ToggleMainWrap_custom">
                    <label>Pre-order</label>
                    <CommonToggle
                      isBadgeAllow={true}
                      badgeTitle={"yes_no"}
                      valueToggle={IsPreOrder}
                      setValueToggle={() => setIsPreOrder(!IsPreOrder)}
                      name={""}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <div
                      className="selectMultiselect selectMultiselectBrand"
                      id="selectMultiselectBrand"
                    >
                      <Select
                        onChange={(e) => FranchiseSelect(e)}
                        isClearable
                        options={optionsAllDealerFranchise}
                        className="godown-select-container"
                        classNamePrefix="godown-select"
                        placeholder={`Select ${
                          DistributorAllow ? "Distributor" : "Franchise"
                        }`}
                        styles={customStyles}
                        filterOption={customFilterOption}
                      />
                    </div>
                  </Form.Group>
                </div>
                {IsPreOrder && (
                  <div className="col-md-12">
                    <div
                      className="alert alert-info"
                      style={{ marginBottom: "15px", fontSize: "13px" }}
                    >
                      <i className="bi bi-info-circle-fill me-2"></i>
                      This is a pre order booking flow. These orders will not
                      go in draft orders and will be processed once
                      production fulfills. Please contact Chetan Magare for
                      more details (+917385715549).
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="formloginset">
              <div className="row">
                <div className="col-md-3">
                  <Form.Group className="mb-3">
                    <div className="smallLabelData">
                      <small>Selected Franchise</small>
                      <div>{GetCurrentDealerFranchiseType?.customer_name}</div>
                      <span
                        className="clearbtn"
                        onClick={() => PurchaseOrderMainClear()}
                      >
                        <i className="bi bi-x-circle-fill"></i>
                      </span>
                    </div>
                  </Form.Group>
                </div>
                {PermissionStockInwardModule?.permissionStockInward ===
                "Bundles" ? (
                  <React.Fragment>
                    <div className="col-md-3">
                      <Form.Group className="mb-3">
                        <div
                          className="selectMultiselect selectMultiselectBrand"
                          id="selectMultiselectBrand"
                        >
                          <Select
                            onChange={(e) => BundlesSelect(e)}
                            value={selectBundlesItem}
                            isClearable
                            options={optionsBundlesItems}
                            className="godown-select-container"
                            classNamePrefix="godown-select"
                            placeholder="Select Bundles"
                            styles={customStyles}
                            filterOption={customFilterOption}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn exportbtn"
                        disabled={!selectBundlesItem}
                        id="PurchaseOrderbtn"
                        onClick={() => PurchaseOrderAdd()}
                      >
                        Add
                      </button>
                      <button
                        className="btn exportbtn"
                        style={{ marginLeft: "10px" }}
                        id="PurchaseOrderClearbtn"
                        onClick={() => PurchaseBundlesOrderClear()}
                      >
                        Clear
                      </button>
                    </div>
                  </React.Fragment>
                ) : PermissionStockInwardModule?.permissionStockInward ===
                  "Spares" ? (
                  <React.Fragment>
                    <div className="col-md-4">
                      <Form.Group className="mb-3">
                        <div
                          className="selectMultiselect selectMultiselectBrand"
                          id="selectMultiselectBrand"
                        >
                          <Select
                            onChange={(e) => ProductSparesSelect(e)}
                            value={sparesCampatProduct}
                            isClearable
                            options={optionsparescampatibiityAllList}
                            className="godown-select-container"
                            classNamePrefix="godown-select"
                            placeholder="Select Products"
                            styles={customStyles}
                            filterOption={customFilterOption}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-2">
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="number"
                          value={AddQuantity}
                          className="inputBoxs"
                          onChange={onChange}
                          onKeyDown={(e) => {
                            EmptySpaceFieldValid(e);
                            exceptThisCostSymbols.includes(e.key) &&
                              e.preventDefault();
                          }}
                          placeholder="Enter Quantity"
                          maxLength={3}
                          min="1"
                          max="10"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn exportbtn"
                        disabled={!sparesCampatProduct || !AddQuantity}
                        id="PurchaseOrderbtn"
                        onClick={() => PurchaseOrderAdd()}
                      >
                        Add
                      </button>
                      <button
                        className="btn exportbtn"
                        style={{ marginLeft: "10px" }}
                        id="PurchaseOrderClearbtn"
                        onClick={() => PurchaseOrderClear()}
                      >
                        Clear
                      </button>
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="col-md-3">
                      <Form.Group className="mb-3">
                        <div
                          className="selectMultiselect selectMultiselectBrand"
                          id="selectMultiselectBrand"
                        >
                          <Select
                            onChange={(e) => ProductSelect(e)}
                            value={selectProduct}
                            isClearable
                            options={UpdateOptionPorducts}
                            className="godown-select-container"
                            classNamePrefix="godown-select"
                            placeholder="Select Products"
                            styles={customStyles}
                            filterOption={customFilterOption}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <Form.Group className="mb-3">
                        <div
                          className="selectMultiselect selectMultiselectCategory"
                          id="selectMultiselectBrand"
                        >
                          <Select
                            onChange={(e) => CategorySelect(e)}
                            value={selectCategory}
                            // defaultValue={DefaultCategory}
                            isClearable
                            options={optionsCategory}
                            className="godown-select-container"
                            classNamePrefix="godown-select"
                            placeholder="Select Category"
                            styles={customStyles}
                            isDisabled={FilterDisable}
                            filterOption={customFilterOption}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <Form.Group className="mb-3">
                        <div
                          className="selectMultiselect selectMultiselectCategory"
                          id="selectMultiselectBrand"
                        >
                          <Select
                            onChange={(e) => SubCategorySelect(e)}
                            value={selectSubCategory}
                            // defaultValue={DefaultSubCategory}
                            // isClearable
                            options={optionsSubCategory}
                            className="godown-select-container"
                            classNamePrefix="godown-select"
                            placeholder="Select Sub Category"
                            styles={customStyles}
                            isDisabled={FilterDisable}
                            filterOption={customFilterOption}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <Form.Group className="mb-3">
                        <div
                          className="selectMultiselect selectMultiselectCategory"
                          id="selectMultiselectBrand"
                        >
                          <Select
                            onChange={(e) => ItemSelect(e)}
                            value={selectItemName}
                            // defaultValue={DefaultSubCategory}
                            // isClearable
                            options={optionsItemName}
                            className="godown-select-container"
                            classNamePrefix="godown-select"
                            placeholder="Select Item Name"
                            styles={customStyles}
                            isDisabled={FilterDisable}
                            filterOption={customFilterOption}
                          />
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-md-3">
                      <Form.Group className="mb-3">
                        <Form.Control
                          type="number"
                          value={AddQuantity}
                          className="inputBoxs"
                          onChange={onChange}
                          onKeyDown={(e) => {
                            EmptySpaceFieldValid(e);
                            exceptThisCostSymbols.includes(e.key) &&
                              e.preventDefault();
                          }}
                          placeholder="Enter Quantity"
                          maxLength={3}
                          min="1"
                          max="10"
                        />
                      </Form.Group>
                    </div>
                    {GetCurrentDealerFranchiseType?.is_flexible_pricing &&
                      GetCurrentDealerFranchiseType?.is_flexible_pricing !==
                        undefined && (
                        <div className="col-md-3">
                          <Form.Group className="mb-3">
                            <Form.Control
                              type="number"
                              value={AddRate}
                              className="inputBoxs"
                              onChange={onChangeRate}
                              onKeyDown={(e) => {
                                EmptySpaceFieldValid(e);
                                exceptThisCostSymbols.includes(e.key) &&
                                  e.preventDefault();
                              }}
                              placeholder="Enter Rate"
                              maxLength={3}
                            />
                          </Form.Group>
                        </div>
                      )}
                    <div className="col-md-3" style={{ width: "19%" }}>
                      <div className="ToggleMainWrap_custom">
                        <label>Is Demo</label>
                        <CommonToggle
                          isBadgeAllow={true}
                          badgeTitle={"yes_no"}
                          valueToggle={IsDemo}
                          setValueToggle={() => setIsDemo(!IsDemo)}
                          name={""}
                        />
                      </div>
                      {/* <Form.Group className="mb-3" >
                                    <div className="ToggleMainWrap">
                                        <label>Is Demo</label>
                                        <CommonToggle 
                                            valueToggle={IsDemo}
                                            setValueToggle={() => setIsDemo(!IsDemo)}
                                            name={""}
                                        />
                                        {IsDemo ? <Badge bg="success">Yes</Badge> : <Badge bg="danger">No</Badge>} 
                                    </div>
                                </Form.Group> */}
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn exportbtn"
                        disabled={!DisableAddButton}
                        id="PurchaseOrderbtn"
                        onClick={() => PurchaseOrderAdd()}
                      >
                        Add
                      </button>
                      <button
                        className="btn exportbtn"
                        style={{ marginLeft: "10px" }}
                        id="PurchaseOrderClearbtn"
                        onClick={() => PurchaseOrderClear()}
                      >
                        Clear
                      </button>
                    </div>
                  </React.Fragment>
                )}
                <div
                  className="FranchiseWallet"
                  style={{ justifyContent: "flex-start", columnGap: "10px" }}
                >
                  {/* <div className="FranchiseBlance_name">
                    <label>
                      <i className="bi bi-wallet-fill"></i> Erp Credit Limit:
                    </label>
                    ₹ {GetAvailableBalance()?.erp_credit_limit}
                  </div>
                  <div className="FranchiseBlance_name">
                    <label>
                      <i className="bi bi-wallet-fill"></i> Erp Outstanding:
                    </label>
                    ₹ {GetAvailableBalance()?.erp_outstanding}
                  </div> */}
                  <div className="FranchiseBlance_name">
                    <label>
                      <i className="bi bi-wallet-fill"></i> Outstanding above
                      90+:
                    </label>
                    ₹{" "}
                    {Math.max(
                      parseInt(erpAccountListSOrder?.list[0]?.range4) +
                        parseInt(erpAccountListSOrder?.list[0]?.range5),
                      0,
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      <div className="tableView">
        <CommonScrollBar
          className={"ScrollbarsSidebar ScrollbarsSidebarHorizontal"}
          height={{
            height:
              PermissionStockInwardModule?.permissionStockInward ===
              "E-Bikes,Accessories"
                ? PreviewOrder
                  ? "calc(100vh - 136px)"
                  : GetCurrentDealerFranchiseType === undefined
                    ? "calc(100vh - 217px)"
                    : GetCurrentDealerFranchiseType?.is_flexible_pricing
                      ? "calc(100vh - 371px)"
                      : PermissionStockInwardModule?.permissionStockInward ===
                          "Bundles"
                        ? "calc(100vh - 325px)"
                        : "calc(100vh - 325px)"
                : PreviewOrder
                  ? "calc(100vh - 136px)"
                  : GetCurrentDealerFranchiseType === undefined
                    ? "calc(100vh - 217px)"
                    : GetCurrentDealerFranchiseType?.is_flexible_pricing
                      ? "calc(100vh - 285px)"
                      : PermissionStockInwardModule?.permissionStockInward ===
                          "Bundles"
                        ? "calc(100vh - 270px)"
                        : "calc(100vh - 270px)",
          }}
        >
          {PreviewOrder && (
            <div className="FranchiseWallet">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  float: "left",
                  width: "100%",
                }}
              >
                <div className="Franchise_name">
                  <label>Franchise Name:</label>
                  {GetCurrentDealerFranchiseType?.customer_name}
                </div>
                <div className="FranchiseBlance_name">
                  <label>
                    <i className="bi bi-wallet-fill"></i> Available Balance:
                  </label>
                  ₹ {GetAvailableBalance()?.available_balance}
                </div>
              </div>
              <button
                className="btn btn-link backbtn"
                onClick={() => BackFunction()}
                style={{ display: "flex" }}
              >
                <i className="bi bi-arrow-left-short"></i> Back
              </button>
            </div>
          )}

          {ProductListOrder?.length > 0 && (
            <>
              <div className="tableView">
                <Table>
                  <thead>
                    <tr>
                      <th>SNO</th>
                      <th>Product Code</th>
                      {PermissionStockInwardModule?.permissionStockInward ===
                      "Spares" ? (
                        <th style={{ width: "30%" }}>Compatible Items</th>
                      ) : (
                        <th>Is Demo</th>
                      )}
                      <th>Product Name</th>
                      <th>Rate</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                      {GetCurrentDealerFranchiseType?.is_flexible_pricing &&
                        PermissionStockInwardModule?.permissionStockInward !==
                          "Spares" && <th>Rate</th>}
                      {!PreviewOrder &&
                        PermissionStockInwardModule?.permissionStockInward !==
                          "Bundles" && <th>Action</th>}

                        <th
                          style={{
                            whiteSpace: "pre-line",
                            borderLeftWidth: "1px",
                            borderColor: "#ddd",
                            textAlign: "center",
                          }}
                        >
                          Upcoming Qty
                        </th>
                      <th
                        style={{
                          whiteSpace: "pre-line",
                          borderLeftWidth: "1px",
                          borderColor: "#ddd",
                          textAlign: "center",
                        }}
                      >
                        RGL Pune Chakan
                      </th>
                      <th
                        style={{
                          whiteSpace: "pre-line",
                          borderLeftWidth: "1px",
                          borderColor: "#ddd",
                          textAlign: "center",
                        }}
                      >
                        RGL Delhi
                      </th>
                      <th
                        style={{
                          whiteSpace: "pre-line",
                          borderLeftWidth: "1px",
                          borderColor: "#ddd",
                          textAlign: "center",
                        }}
                      >
                        RGL Bangalore
                      </th>
                      <th
                        style={{
                          whiteSpace: "pre-line",
                          borderLeftWidth: "1px",
                          borderColor: "#ddd",
                          textAlign: "center",
                        }}
                      >
                        RGL Kolkata
                      </th>
                      <th
                        style={{
                          whiteSpace: "pre-line",
                          borderLeftWidth: "1px",
                          borderColor: "#ddd",
                          textAlign: "center",
                        }}
                      >
                        Accessories WH
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ProductListOrder?.map((elm, index) => {
                      const GetProductDetails = productlistall?.filter(
                        (elms) => elms?.id === elm?.product?.id,
                      )[0];
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          {PermissionStockInwardModule?.permissionStockInward ===
                          "Spares" ? (
                            <td>{GetProductDetails?.erp_id}</td>
                          ) : (
                            <td>{GetProductDetails?.product_code}</td>
                          )}
                          {PermissionStockInwardModule?.permissionStockInward ===
                          "Spares" ? (
                            <td>
                              {elm?.product?.custom_is_transportation
                                ? "Transportation Charges"
                                : GetSparesProductList(elm?.compatible_items)}
                            </td>
                          ) : (
                            <td>
                              {elm?.is_demo ? (
                                <Badge bg="success">Yes</Badge>
                              ) : (
                                <Badge bg="danger">No</Badge>
                              )}
                            </td>
                          )}
                          <td>{GetProductDetails?.product_name}</td>
                          <td>
                            {PermissionStockInwardModule?.permissionStockInward ===
                            "Spares" ? (
                              <React.Fragment>
                                {elm?.product?.custom_is_transportation ? (
                                  <div className="spares_input_box">
                                    ₹
                                    <input
                                      type="number"
                                      className="form-control inputBoxs"
                                      value={elm.rate}
                                      onChange={(e) =>
                                        TransportationRatingCustom(
                                          e.target.value.replace(/^0/g, ""),
                                          elm,
                                        )
                                      }
                                      onKeyDown={(e) => {
                                        EmptySpaceFieldValid(e);
                                        exceptThisCostSymbolsBox.includes(
                                          e.key,
                                        ) && e.preventDefault();
                                        // Prevent only the up and down arrow keys
                                        if (
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                      maxLength={2}
                                      max={2}
                                    />
                                  </div>
                                ) : (
                                  "₹" + AmountNumberFormat(elm?.rate)
                                )}
                              </React.Fragment>
                            ) : (
                              AmountNumberFormat(
                                GetCurrentOrderRate(elm, GetProductDetails)
                                  ?.price,
                              )
                            )}
                          </td>
                          <td>
                            {PermissionStockInwardModule?.permissionStockInward ===
                              "Bundles" ||
                            PermissionStockInwardModule?.permissionStockInward ===
                              "Spares" ? (
                              elm?.quantity
                            ) : (
                              <>
                                {PreviewOrder ? (
                                  elm?.quantity
                                ) : (
                                  <div className="QauntityManage">
                                    <button
                                      className="btn remove"
                                      onClick={() =>
                                        removeQuantity(elm?.id, elm?.quantity)
                                      }
                                    >
                                      <i className="bi bi-dash-circle-fill"></i>
                                    </button>
                                    <h2>{elm?.quantity}</h2>
                                    <button
                                      className="btn add"
                                      onClick={() => addMainQuantity(elm?.id)}
                                    >
                                      <i className="bi bi-plus-circle-fill"></i>
                                    </button>
                                  </div>
                                )}
                              </>
                            )}
                          </td>
                          <td>
                            ₹{" "}
                            {PermissionStockInwardModule?.permissionStockInward ===
                            "Spares"
                              ? isNaN(elm?.sub_total)
                                ? 0
                                : elm?.sub_total
                              : AmountNumberFormat(
                                  GetCurrentOrderRate(elm, GetProductDetails)
                                    ?.sub_total,
                                )}
                          </td>
                          {GetCurrentDealerFranchiseType?.is_flexible_pricing &&
                            PermissionStockInwardModule?.permissionStockInward !==
                              "Spares" && <td>{elm?.amount}</td>}
                          {!PreviewOrder &&
                            PermissionStockInwardModule?.permissionStockInward !==
                              "Bundles" && (
                              <td>
                                <Button
                                  className="btn edittable"
                                  onClick={() => DeleteOrder(elm?.id)}
                                  style={{ marginLeft: "7px" }}
                                >
                                  <img src={DeleteIcon} alt="delete_icon" />
                                </Button>
                              </td>
                            )}
                          <td
                            style={{
                              borderLeftWidth: "1px",
                              borderColor: "#ddd",
                              textAlign: "center",
                            }}
                          >
                            {elm.product.stock_level
                              ?.filter(
                                (warehouse) => warehouse?.is_virtual_wh === true,
                              )
                              ?.reduce(
                                (sum, warehouse) =>
                                  sum + Number(warehouse?.balance_qty ?? 0),
                                0,
                              ) ?? 0}
                          </td>
                          <td
                            style={{
                              borderLeftWidth: "1px",
                              borderColor: "#ddd",
                              textAlign: "center",
                              backgroundColor:
                                Number(
                                  elm.product.stock_level?.find(
                                    (warehouse) =>
                                      warehouse.warehouse_id ===
                                      process.env.REACT_APP_RGL_PUNE_CHAKAN,
                                  )?.balance_qty ?? 0,
                                ) <= 5
                                  ? "#FFD5D5"
                                  : Number(
                                        elm.product.stock_level?.find(
                                          (warehouse) =>
                                            warehouse.warehouse_id ===
                                            process.env.REACT_APP_RGL_PUNE_CHAKAN,
                                        )?.balance_qty ?? 0,
                                      ) <= 20
                                    ? "#feffa8"
                                    : "#cdffbe",
                            }}
                          >
                            {elm.product.stock_level?.find(
                              (warehouse) =>
                                warehouse.warehouse_id ===
                                process.env.REACT_APP_RGL_PUNE_CHAKAN,
                            )?.balance_qty ?? "0"}
                          </td>

                          <td
                            style={{
                              borderLeftWidth: "1px",
                              borderColor: "#ddd",
                              textAlign: "center",
                              backgroundColor:
                                Number(
                                  elm.product.stock_level?.find(
                                    (warehouse) =>
                                      warehouse.warehouse_id ===
                                      process.env.REACT_APP_RGL_DELHI,
                                  )?.balance_qty ?? 0,
                                ) <= 5
                                  ? "#FFD5D5"
                                  : Number(
                                        elm.product.stock_level?.find(
                                          (warehouse) =>
                                            warehouse.warehouse_id ===
                                            process.env.REACT_APP_RGL_DELHI,
                                        )?.balance_qty ?? 0,
                                      ) <= 20
                                    ? "#feffa8"
                                    : "#cdffbe",
                            }}
                          >
                            {elm.product.stock_level?.find(
                              (warehouse) =>
                                warehouse.warehouse_id ===
                                process.env.REACT_APP_RGL_DELHI,
                            )?.balance_qty ?? "0"}
                          </td>

                          <td
                            style={{
                              borderLeftWidth: "1px",
                              borderColor: "#ddd",
                              textAlign: "center",
                              backgroundColor:
                                Number(
                                  elm.product.stock_level?.find(
                                    (warehouse) =>
                                      warehouse.warehouse_id ===
                                      process.env.REACT_APP_RGL_BANGALORE,
                                  )?.balance_qty ?? 0,
                                ) <= 5
                                  ? "#FFD5D5"
                                  : Number(
                                        elm.product.stock_level?.find(
                                          (warehouse) =>
                                            warehouse.warehouse_id ===
                                            process.env.REACT_APP_RGL_BANGALORE,
                                        )?.balance_qty ?? 0,
                                      ) <= 20
                                    ? "#feffa8"
                                    : "#cdffbe",
                            }}
                          >
                            {elm.product.stock_level?.find(
                              (warehouse) =>
                                warehouse.warehouse_id ===
                                process.env.REACT_APP_RGL_BANGALORE,
                            )?.balance_qty ?? "0"}
                          </td>

                          <td
                            style={{
                              borderLeftWidth: "1px",
                              borderColor: "#ddd",
                              textAlign: "center",
                              backgroundColor:
                                Number(
                                  elm.product.stock_level?.find(
                                    (warehouse) =>
                                      warehouse.warehouse_id ===
                                      process.env.REACT_APP_RGL_KOLKATA,
                                  )?.balance_qty ?? 0,
                                ) <= 5
                                  ? "#FFD5D5"
                                  : Number(
                                        elm.product.stock_level?.find(
                                          (warehouse) =>
                                            warehouse.warehouse_id ===
                                            process.env.REACT_APP_RGL_KOLKATA,
                                        )?.balance_qty ?? 0,
                                      ) <= 20
                                    ? "#feffa8"
                                    : "#cdffbe",
                            }}
                          >
                            {elm.product.stock_level?.find(
                              (warehouse) =>
                                warehouse.warehouse_id ===
                                process.env.REACT_APP_RGL_KOLKATA,
                            )?.balance_qty ?? "0"}
                          </td>
                          <td
                            style={{
                              borderLeftWidth: "1px",
                              borderColor: "#ddd",
                              textAlign: "center",
                              backgroundColor:
                                Number(
                                  elm.product.stock_level?.find(
                                    (warehouse) =>
                                      warehouse.warehouse_id ===
                                      process.env.REACT_APP_ACC_WH,
                                  )?.balance_qty ?? 0,
                                ) <= 5
                                  ? "#FFD5D5"
                                  : Number(
                                        elm.product.stock_level?.find(
                                          (warehouse) =>
                                            warehouse.warehouse_id ===
                                            process.env.REACT_APP_ACC_WH,
                                        )?.balance_qty ?? 0,
                                      ) <= 20
                                    ? "#feffa8"
                                    : "#cdffbe",
                            }}
                          >
                            {elm.product.stock_level?.find(
                              (warehouse) =>
                                warehouse.warehouse_id ===
                                process.env.REACT_APP_ACC_WH,
                            )?.balance_qty ?? "0"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              {!PreviewOrder && (
                <div className="btnGroupswraps" id="btnGroupswraps">
                  <Button
                    className="Addbtn"
                    onClick={() => {
                      PrviewOrderCarts();
                      CheckAvailableBalanceModal();
                    }}
                  >
                    Preview
                  </Button>
                </div>
              )}
              {PreviewOrder && (
                <>
                  <ul className="GSTAmounttotal">
                    <li className="totaltd">
                      <label>GST: &nbsp;</label>₹{" "}
                      {AmountNumberFormat(GetGSTAmount()?.total_gst)}
                    </li>
                    <li className="totaltd">
                      <label>Net Amount: &nbsp;</label>₹{" "}
                      {AmountNumberFormat(GetGSTAmount()?.total)}
                    </li>
                    <li className="totaltd">
                      <label>Remarks (Optional): &nbsp;</label>
                      <textarea
                        className="form-control"
                        value={ApplicationState?.Remark}
                        onChange={(e) =>
                          setApplicationState({
                            ...ApplicationState,
                            Remark: e.target.value,
                          })
                        }
                        onKeyDown={EmptySpaceFieldValid}
                      ></textarea>
                    </li>
                  </ul>
                  <div className="formloginset">
                    <div className="HeaderDivider">
                      <h6 className="subtitleForm PurchaseOrderCheckbox">
                        Delivery Address
                      </h6>
                      <div className="row">
                        <div className="col-md-4">
                          <Form.Group className="mb-3 ">
                            <Form.Label>
                              Franchise Selected Dealer Sub-Dealers
                            </Form.Label>
                            <div
                              className="selectMultiselect selectMultiselectCategory"
                              id="selectMultiselectBrand"
                            >
                              <Select
                                onChange={(e) =>
                                  selectFranchiseDeliveryAddress(e)
                                }
                                value={FranchiseDealerAddress}
                                options={FranchiseListStateVarsOptions}
                                className="godown-select-container"
                                classNamePrefix="godown-select"
                                placeholder="Select Franchise"
                                styles={customStyles}
                                filterOption={customFilterOption}
                              />
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-md-8">
                          <Form.Group className="mb-3 ">
                            <Form.Label>
                              Customer name
                              <span className="mendatory_star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={ApplicationState?.Name}
                              onChange={(e) =>
                                setApplicationState({
                                  ...ApplicationState,
                                  Name: e.target.value,
                                })
                              }
                              onKeyUp={(e) =>
                                CheckValid(e.target.value, {
                                  type: "Customername",
                                  error: seterrorName,
                                })
                              }
                              onKeyDown={EmptySpaceFieldValid}
                              placeholder="Enter Customer name"
                              disabled={FranchiseDealerAddress?.id !== ""}
                            />
                            {errorName !== "" && (
                              <span className="error_medotory">
                                {errorName}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <Form.Group className="mb-3 ">
                            <Form.Label>
                              Mobile Number
                              <span className="mendatory_star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              className="inputBoxs"
                              value={ApplicationState?.Mobile}
                              onChange={(e) =>
                                setApplicationState({
                                  ...ApplicationState,
                                  Mobile: e.target.value.replace(/^0/, ""),
                                })
                              }
                              onKeyUp={(e) =>
                                CheckValid(e.target.value, {
                                  type: "phone",
                                  error: seterrorMobile,
                                })
                              }
                              onKeyDown={(e) => {
                                EmptySpaceFieldValid(e);
                                exceptThisCostSymbols.includes(e.key) &&
                                  e.preventDefault();
                              }}
                              placeholder="Enter Mobile Number"
                              // disabled={FranchiseDealerAddress?.id !== ""}
                            />
                            {errorMobile !== "" && (
                              <span className="error_medotory">
                                {errorMobile}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group className="mb-3 ">
                            <Form.Label>
                              Email Address
                              <span className="mendatory_star">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              value={ApplicationState?.Email}
                              onChange={(e) =>
                                setApplicationState({
                                  ...ApplicationState,
                                  Email: e.target.value,
                                })
                              }
                              onKeyUp={(e) =>
                                CheckValid(e.target.value, {
                                  type: "email",
                                  error: seterrorEmail,
                                })
                              }
                              onKeyDown={EmptySpaceFieldValid}
                              placeholder="Enter Email Address"
                              // disabled={FranchiseDealerAddress?.id !== ""}
                            />
                            {errorEmail !== "" && (
                              <span className="error_medotory">
                                {errorEmail}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group className="mb-3">
                            <Form.Label>
                              PIN Code
                              <span className="mendatory_star">*</span>
                              <OverlayTrigger
                                placement="left"
                                delay={{ show: 250, hide: 100 }}
                                overlay={
                                  <Tooltip
                                    style={{ position: "fixed" }}
                                    id="button-tooltip"
                                    {...props}
                                  >
                                    Search by either hitting the enter button or
                                    clicking on the search icon.
                                  </Tooltip>
                                }
                              >
                                <small className="filedinfomsg">
                                  <i className="bi bi-info-circle-fill"></i>
                                </small>
                              </OverlayTrigger>
                            </Form.Label>
                            <div className="serachBoxWIth">
                              <Form.Control
                                type="text"
                                value={ApplicationState?.PINCode}
                                onChange={(e) => PinCOdeSearchFunction(e)}
                                onKeyUp={(e) =>
                                  CheckValid(e.target.value, {
                                    type: "PINCode",
                                    error: seterrorPINCode,
                                  })
                                }
                                onKeyDown={(e) => {
                                  EmptySpaceFieldValid(e);
                                  onEnterPincodeSearch(e);
                                }}
                                disabled={commonLoader}
                                maxLength={6}
                                placeholder="Enter PIN Code"
                              />
                              <Button
                                className="searchbtn"
                                onClick={() => SearchPincode()}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="icon icon-tabler icon-tabler-search"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  strokeWidth="2"
                                  stroke="currentColor"
                                  fill="none"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  ></path>
                                  <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                                  <path d="M21 21l-6 -6"></path>
                                </svg>
                              </Button>
                              {ErrorMessageFromReddux?.API ===
                                "pin_code_search" && (
                                <>
                                  <div className="pincode_error">
                                    {ErrorMessageFromReddux?.Error !== "" ? (
                                      <i
                                        className="bi bi-x-circle-fill"
                                        onClick={() =>
                                          setApplicationState({
                                            ...ApplicationState,
                                            PINCode: "",
                                          })
                                        }
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="bi bi-check-circle-fill"
                                        style={{ color: "#10b068" }}
                                      ></i>
                                    )}
                                  </div>
                                </>
                              )}
                              {commonLoader && (
                                <Spinner animation="border" role="status">
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </Spinner>
                              )}
                            </div>
                            {errorPINCode !== "" && (
                              <span className="error_medotory">
                                {errorPINCode}
                              </span>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group className="mb-3 ">
                            <Form.Label>City</Form.Label>
                            <div className="defaultvalueField">
                              {ErrorMessageFromReddux?.Error === ""
                                ? searchPincodeList?.city?.district_name
                                : ""}
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group className="mb-3 ">
                            <Form.Label>State</Form.Label>
                            <div className="defaultvalueField">
                              {ErrorMessageFromReddux?.Error === ""
                                ? searchPincodeList?.state?.state_name
                                : ""}
                            </div>
                          </Form.Group>
                        </div>
                        <div className="col-md-4">
                          <Form.Group className="mb-3 ">
                            <Form.Label>PAN(Optional)</Form.Label>
                            <Form.Control
                              type="text"
                              value={ApplicationState?.PANCard}
                              onChange={(e) =>
                                setApplicationState({
                                  ...ApplicationState,
                                  PANCard: e.target.value,
                                })
                              }
                              onKeyDown={EmptySpaceFieldValid}
                              placeholder="Enter PAN"
                            />
                          </Form.Group>
                        </div>
                      </div>
                      <div className="row">
                        {FranchiseDealerAddress?.customer_name !== "Other" && (
                          <div className="col-md-4">
                            <Form.Group className="mb-3 ">
                              <Form.Label>GSTIN(Optional)</Form.Label>
                              <Form.Control
                                type="text"
                                value={ApplicationState?.GSTIN}
                                onChange={(e) =>
                                  setApplicationState({
                                    ...ApplicationState,
                                    GSTIN: e.target.value,
                                  })
                                }
                                onKeyDown={EmptySpaceFieldValid}
                                onKeyUp={(e) =>
                                  GSTINvalidKeyUp(e?.target?.value)
                                }
                                placeholder="Enter GSTIN"
                                disabled={FranchiseDealerAddress?.id === ""}
                              />
                              {ApplicationState?.GSTIN?.length > 0 &&
                                errorGSTIN !== "" && (
                                  <span className="error_medotory">
                                    {errorGSTIN}
                                  </span>
                                )}
                            </Form.Group>
                          </div>
                        )}
                        <div className="col-md-4">
                          <CommonAddressTextField
                            Label={"Address Line 1"}
                            MainState={ApplicationState}
                            setMainState={setApplicationState}
                            Address={"Address"}
                            isMendatory={true}
                            ErrorAddress={errorAddress}
                            setErrorAddress={seterrorAddress}
                            MaxLength={100}
                          />
                        </div>
                        <div className="col-md-4">
                          <CommonAddressTextField
                            Label={"Address Line 2(Optional)"}
                            MainState={ApplicationState}
                            setMainState={setApplicationState}
                            Address={"address2"}
                            isMendatory={false}
                            MaxLength={100}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div
                          className="col-md-12"
                          style={{ textAlign: "right" }}
                        >
                          {PermissionStockInwardModule?.permissionStockInward ===
                          "Spares" ? (
                            <>
                              {selfInfo?.user?.user_type === "super_admin" ||
                              PermissionsAccess?.OrderManagement[20]?.Edit ? (
                                <Button
                                  className="formbtn"
                                  id="confimr_order_main"
                                  onClick={() => OrderPurchaseFunct()}
                                  style={{ width: "auto", marginTop: "0px" }}
                                  variant="primary"
                                >
                                  Confirm Order
                                </Button>
                              ) : (
                                <span style={{ color: "red" }}>
                                  You don't have permission to create an order.
                                </span>
                              )}
                            </>
                          ) : (
                            <>
                              {selfInfo?.user?.user_type === "super_admin" ||
                              PermissionsAccess?.OrderManagement[1]?.Edit ? (
                                <Button
                                  className="formbtn"
                                  id="confimr_order_main"
                                  onClick={() => OrderPurchaseFunct()}
                                  style={{ width: "auto", marginTop: "0px" }}
                                  variant="primary"
                                >
                                  Confirm Order
                                </Button>
                              ) : (
                                <span style={{ color: "red" }}>
                                  You don't have permission to create an order.
                                </span>
                              )}
                            </>
                          )}
                          <Button
                            className="formbtnback"
                            id="backbtbackgt"
                            style={{ width: "auto", marginLeft: "10px" }}
                            onClick={() => setPreviewOrder(false)}
                          >
                            Back
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </CommonScrollBar>
      </div>

      {showModalNew?.open && (
        <CommonewModel
          ConfirmOrder={ConfirmOrder}
          setShowModalNew={setShowModalNew}
          showModalNew={showModalNew}
        />
      )}
    </section>
  );
};

export default FranchiseOrderTab;
